import { apiConstants } from "../../utils/apiConstants";
import { apiTypes } from "../../utils/apiTypes";
import apiRequestType from "../apiRequestType";

const postCSVBulkUpload = (typeOfCSVFlag, data, customConfig) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.MANAGE.UPLOAD_CSV_FILE(typeOfCSVFlag),
    data,
    null,
    customConfig
  );
};

export default postCSVBulkUpload;
